import { render, staticRenderFns } from "./VChat.vue?vue&type=template&id=2e132671"
import script from "./VChat.vue?vue&type=script&lang=js"
export * from "./VChat.vue?vue&type=script&lang=js"
import style0 from "./VChat.vue?vue&type=style&index=0&id=2e132671&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports